import _ from '../lib/underscore_extend';

import BaseModel from './model';
import URI from 'urijs';

var ChallengeModel = BaseModel.extend({
    initialize: function(attr={}, options={}) {
        BaseModel.prototype.initialize.apply(this, arguments);
        this.view = options.view;
        this.featureKeyPrefix = options.featureKeyPrefix;
        this.challengeKeyHeaderName = options.challengeKeyHeaderName;
        this.listenCaptchaReload = _.memoize(this.listenCaptchaReload);
    },
    buildUrl: function() {
        var url;

        url = this.Url;

        url = new URI(url);

        if (this.activeChallengeType) {
            url.addQuery({type: this.activeChallengeType});
        }

        if (this.querySet) {
            url.addQuery(this.querySet);
        }
        return url;
    },
    url: function() {
        return this.buildUrl().toString();
    },
    initializeChallenge: function() {
        var debugEnabled = URI(document.location).search(true).reduce_riddler_complexity,
            featureOptions = this.getChallengeFeatureOptions(),
            loggingEnabled;

        if (!Riddler || !featureOptions) {
            return false;
        }
        if (_.extract('Raven.isSetup')) {
            loggingEnabled = Raven && Raven.isSetup();
        }
        this.activeChallengeType = null;
        this.challengeResolved = false;
        this.listenCaptchaReload();

        this.riddler = new Riddler({
            feature: featureOptions.feature,
            url: featureOptions.url,
            resolved: _.bind(this.newChallenge, this),
            error: _.bind(this.challengeError, this),
            powEvalPath: this.RiddlerLibPath + 'eval.js',
            powSHA3Path: this.RiddlerLibPath + 'sha3.js',
            challengeKeyHeader: this.challengeKeyHeaderName,
            loggingEnabled: loggingEnabled,
            debugEnabled: debugEnabled,
            syncStorageEnabled: featureOptions.syncStorageEnabled,
            errorRequestsLimit: featureOptions.errorRequestsLimit
        });
        this.riddler.solve();
    },
    save: function(attr, options={}) {
        var success = options.success,
            error = options.error,
            context = options.context;

        if (this.challengeResolved) {
            return BaseModel.prototype.save.call(this, attr, _.extend(options, {
                success: (model, result) => {
                    this.riddler.clear();
                    if (success) {
                        success.call(context || this, result);
                    }
                    this.saveSuccess(result);
                },
                error: (model, result) => {
                    if (error) {
                        error.call(context || this, result);
                    }
                    this.syncError(result);
                },
                context: this
            }));
        } else {
            this.onWaitingResolved = () => {
                this.save(attr, options);
            }
        }
    },
    saveSuccess: function() {},
    newChallenge: function(results = {}) {
        var challengeResults = results.results,
            challengeType = results.type,
            challengeKey = results.key;

        if (!challengeResults) {
            // Proof-of-work challenge not solved, fallback to captcha
            this.updateChallenge(Riddler.ChallengeType.CAPTCHA);
            return;
        }

        this.activeChallengeType = challengeType;

        if (challengeType === Riddler.ChallengeType.CAPTCHA) {
            this.useCaptchaChallenge(challengeResults, challengeKey);
        } else if (challengeType === Riddler.ChallengeType.POW) {
            this.usePOWChallenge(challengeResults, challengeKey);
            if (this.onWaitingResolved) {
                this.onWaitingResolved(challengeType);
            }
        }
        this.onWaitingResolved = null;
    },
    updateCaptchaChallenge: function() {
        this.updateChallenge(Riddler.ChallengeType.CAPTCHA);
    },
    updateChallenge: function(challengeType) {
        this.activeChallengeType = null;
        this.challengeResolved = false;

        this.riddler.update(challengeType);
    },
    challengeError: function(error) {
        this.challengeResolved = true;
    },
    syncError: function(response) {
        var result = response.responseJSON || JSON.parse(response.responseText),
            errors = _.extract(result, 'errors'),
            notFoundError = _.contains(_.extract(errors, '__all__', []),'not_found'),
            powError = _.extract(errors, 'pow');

        if (powError || notFoundError) {
            this.updateCaptchaChallenge();
        } else {
            this.updateChallenge();
        }

        this.clear();
    },
    listenCaptchaReload: function() {
        if (!this.view) {
            return false;
        }
        this.view.events = this.view.events || {};
        this.view.events[this.captchaReloadEvent] = _.bind(this.updateCaptchaChallenge, this);
        this.view.delegateEvents();
    },
    captchaReloadEvent: 'reload.challenge.captcha',
    useCaptchaChallenge: function(results, key) {
        if (key) {
            this.set('challenge_id', key);
            this.set('challenge_type', Riddler.ChallengeType.CAPTCHA);
        }
        this.captchaUrl = results.captcha;
        this.challengeResolved = true;
        this.trigger(this.captchaUpdateEvent);
    },
    powUpdateEvent: 'update.challenge.pow',
    captchaUpdateEvent: 'update.challenge.captcha',
    usePOWChallenge: function(results, key) {
        results = _.pairs(results);
        if (key) {
            this.set('challenge_id', key);
            this.set('challenge_type', Riddler.ChallengeType.POW);
        }
        _.each(results, function(result) {
            var name = result[0],
                value = result[1];

            this.set(name, value);
        }, this);
        this.captchaUrl = undefined;
        this.challengeResolved = true;
        this.trigger(this.powUpdateEvent);
    },
    powAllowed: function() {
        var featureOptions = this.getChallengeFeatureOptions();

        if (!featureOptions) {
            return false;
        }
        return _.contains(featureOptions.allowedChallengeTypes, Riddler.ChallengeType.POW);
    },
    getChallengeFeatureOptions: function() {
        var key = this.featureKeyPrefix || this.view && this.view.featureKeyPrefix;
        if (!key) {
            return false;
        }
        return {
            feature: _.extract(key + 'Feature'),
            url: _.extract(key + 'Url'),
            syncStorageEnabled: _.extract(key + 'StorageSync'),
            allowedChallengeTypes: _.extract(key + 'Types'),
            errorRequestsLimit: _.extract(key + 'ErrorRequestsLimit')
        };
    }
});

export default ChallengeModel;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/base/challenge_model.js